import {
  FileCourierDownloadFileProps,
  FileCourierDownloadPackageProps,
} from "interfaces";
import { API_URL } from "utils/environmentVariables";

export const getOrderDirection = (sortBy: string): string => {
  return sortBy.includes("(newest - oldest)") ? "desc" : "asc";
};

export async function downloadFile(fileUrl: string): Promise<boolean> {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = "download";
  document.body.appendChild(link);
  link.click();
  // Add a small delay before removing the element
  await new Promise(resolve => setTimeout(resolve, 250));
  document.body.removeChild(link);
  return true;
}

export async function downloadPackage(packageUrl: string): Promise<boolean> {
  const link = document.createElement("a");
  link.href = packageUrl;
  link.download = "download";
  document.body.appendChild(link);
  link.click();
  await new Promise(resolve => setTimeout(resolve, 250));
  document.body.removeChild(link);
  return true;
}
